import React from 'react'
import Field from './field'
import {Consumer} from '../../../context'

export default function Items(props) {
  return (<Consumer>{context => {
    return (<React.Fragment>
      {props.items.map(field => <Field
        key={field.id}
        className={field.name}
        name={field.content.name}
        context={context}
        sections={field.content.sections}
      />)}
    </React.Fragment>)
  }}</Consumer>)
}

